export const HOMEINDEX = {
  partners: {
    yixin:{
      name: '毅新',
      probability: 50,
      slots: {
        homeIndex_pop: {
          ads: {
            HOMEINDEX_POP: {
              isWatch:false,
              id: 'HOMEINDEX_POP_ADS_A',
              imgUrl: require('@/config/assets/yixin/home/homePops.png'),
              eventName: 'Jump-to-home-props-yixin',
              content: `{"key":"首页props弹窗","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168369141526.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY5MTQxNTI2IiwidHMiOiIxNzgxNTg3NTk5IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImRiN2NjNDJiLWQxYWEtNGUxZS04NzRkLWIxZDQ2MjkwOTgxNVwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYzXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=db7cc42b-d1aa-4e1e-874d-b1d462909815&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
      },
    },
    haohai:{
      name: '浩海',
      probability: 50,
      slots: {
        homeIndex_pop: {
          ads: {
            HOMEINDEX_POP: {
              isWatch:false,
              id: 'HOMEINDEX_POP_ADS_A',
              imgUrl: require('@/config/assets/haohai/home/homePops.png'),
              eventName: 'Jump-to-home-props-haohai',
              content: `{"key":"首页props弹窗","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
      },
    }
  },
}

export const homePageData = ['Jump-to-home-props-yixin','Jump-to-home-props-haohai']
